import React, { useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { AuthContext, SuperAdminProvider } from '../../contexts';
import Layouts from '../../components/layouts';

const AdminConsole = () => {
	useContext(AuthContext);
	return (
		<SuperAdminProvider>
			<Layouts type={'super-admin'}>
				<Outlet />
			</Layouts>
		</SuperAdminProvider>
	);
};

export default AdminConsole;
